export const API = {
	LOGIN: {
		path: 'login',
	},
	SIGNUP: {
		path: 'signup',
	},
	SIGNUP_USER: {
		path: 'signup/user',
	},
	RESET: {
		path: 'client-portal-users/resetPassword',
	},
	NEW_PASSWORD: {
		path: 'client-portal-users/newPassword',
	},
	LIST_USER: {
		path: 'client-portal-users/list',
	},
	INVITE_USER: {
		path: 'client-portal-users/invite-user',
	},
	USER_DETAIL: {
		path: 'client-portal-users/:userID',
	},
	USER: {
		path: 'client-portal-users',
	},
	VERIFY: {
		path: 'client-portal-users/verify',
	},
	COMPANIES: {
		path: 'companies',
	},
	COMPANY_SIGN_S3: {
		path: 'companies/:id/sign_s3',
	},
	ESTIMATES_DETAIL: {
		path: 'estimates/:estimateId',
	},
	ESTIMATES_PAYMENT: {
		path: 'estimates/:estimateId/payments',
	},
	VEHICLE_DETAIL: {
		path: 'estimates/:estimateId/vehicles/:vehicleId'
	},
	ESTIMATES: {
		path: 'estimates',
	},
	WORKORDERS: {
		path: 'workorders'
	},
	WORKORDER_DETAIL: {
		path: 'workorders/:workOrderId',
	},
	PDF_WORKORDER: {
		path: '/pdf/workorders/:recordId',
	},
	INVOICES: {
		path: 'invoices',
	},
	INVOICE_DETAIL: {
		path: 'invoices/:invoiceId',
	},
	PAYMENTS: {
		path: 'payments',
	},
	PAYMENTS_SEND_RECEIPT: {
		path: '/payments/:paymentId/sendReceipt',
	},
	PDF_INVOICE: {
		path: '/pdf/invoices/:recordId',
	},
	PDF_INVOICE_ADAS: {
		path: '/pdf/invoices/:recordId/adas',
	},
	PDF_ESTIMATE: {
		path: '/pdf/estimates/:recordId',
	},
	PDF_ESTIMATE_ADAS: {
		path: '/pdf/estimates/:recordId/adas',
	},
	PDF_ESTIMATE_SUPPLEMENT: {
		path: '/pdf/estimates/:recordId/supplement',
	},
	PDF_ESTIMATE_PARTS: {
		path: '/pdf/estimates/:recordId/parts',
	},
	GET_JOB: {
		path: 'jobs/',
	},
	WORKFLOW: {
		path: 'workflow'
	},
	WORKFLOW_ESTIMATES: {
		path: 'workflow/search/estimates'
	},
	WORKFLOW_WORK_ORDERS: {
		path: 'workflow/search/workOrders'
	},
	WORKFLOW_INVOICES: {
		path: 'workflow/search/invoices'
	},
	WORKFLOW_RELATED_DOCUMENTS: {
		path: 'workflow/related-documents'
	},
	ADAS_REPORTS: {
		path: 'vehicle-reports'
	},
	ADAS_REPORT_DETAIL: {
		path: 'vehicle-reports/:id'
	},
	// US-37724 — the appointment behind a document, and confirm/decline.
	APPOINTMENT_DETAIL: {
		path: 'appointments/:id'
	},
	ADAS_REPORT_READINESS: {
		path: 'vehicle-reports/:id/readiness'
	},
	ADAS_REPORT_SAFETY_FEATURES: {
		path: 'vehicle-reports/:id/safety-features'
	},
	ADAS_REPORT_SENSOR_ANSWER: {
		path: 'vehicle-reports/:id/sensor-answer'
	},
	ADAS_REPORT_PDF: {
		path: 'vehicle-reports/:id/pdf'
	},
	// The estimate PDF the user uploaded (signed, inline) — NOT the generated
	// ADAS report PDF above. Opened from a failed row in the list.
	ADAS_REPORT_SOURCE_DOCUMENT: {
		path: 'vehicle-reports/:id/source-document'
	},
	ADAS_REPORT_UPLOAD: {
		path: 'vehicle-reports/upload'
	},
	ADAS_REPORT_VENDORS: {
		path: 'vehicle-reports/vendors/list'
	}
}
